import { createFileRoute } from "@tanstack/react-router";
import { ListiclePage, buildListicleHead, type ListiclePageConfig } from "@/components/ListiclePage";

const CONFIG: ListiclePageConfig = {
  slug: "top-10-colorado-small-business-website-mistakes",
  metaTitle: "10 Colorado Small Business Website Mistakes (And How to Fix Them) | Colorado Web Impressions",
  metaDescription: "After auditing hundreds of Colorado small business websites, the same fixable mistakes show up over and over. Here are the top 10 — ranked by how much reve",
  breadcrumbs: [
    { label: "Home", to: "/" },
    { label: "Insights", to: "/learn" },
  ],
  currentLabel: "Top Mistakes — Colorado",
  eyebrow: "Top Mistakes — Colorado",
  h1: <>{"10 Colorado Small Business Website Mistakes (And How to Fix Them)"}</>,
  heroDescription: "After auditing hundreds of Colorado small business websites, the same fixable mistakes show up over and over.",
  intro: "After auditing hundreds of Colorado small business websites, the same fixable mistakes show up over and over. Here are the top 10 — ranked by how much revenue they cost the business.",
  methodology: ["Based on real Colorado small business audits and projects", "Ranked by revenue impact, not opinion", "Patterns are repeatable — no proprietary tools required", "Updated quarterly as Colorado SERPs shift"],
  items: [
    {
      rank: 1,
      name: "Slow mobile load (>3 seconds)",
      whatWeLike: ["Most Colorado small business sites lose 40%+ of mobile visitors before the page even paints. Compress images, drop the page builder, and hand-code the critical path."],
    },
    {
      rank: 2,
      name: "No sticky click-to-call button",
      whatWeLike: ["Phone visible on every scroll is the single highest-ROI change you can make for a service business."],
    },
    {
      rank: 3,
      name: "Generic stock photos",
      whatWeLike: ["Colorado homeowners can tell. Real photos of your truck, team, and jobsite outperform stock by 2–3x on conversion."],
    },
    {
      rank: 4,
      name: "Missing service-area pages",
      whatWeLike: ["One \"service areas\" list page can't rank for every city. Each priority city needs its own page with unique content."],
    },
    {
      rank: 5,
      name: "No FAQ schema",
      whatWeLike: ["FAQ markup unlocks rich results in Google. Most Colorado small business sites skip it entirely."],
    },
    {
      rank: 6,
      name: "Buried Google reviews",
      whatWeLike: ["Reviews must be above the fold, not in a footer carousel. Trust closes the call."],
    },
    {
      rank: 7,
      name: "Long contact forms",
      whatWeLike: ["Every extra field cuts conversion. Name + phone is enough for first contact."],
    },
    {
      rank: 8,
      name: "No clear pricing or starting-from anchor",
      whatWeLike: ["Visitors won't call without a rough number. Even a starting-from price doubles inbound rate."],
    },
    {
      rank: 9,
      name: "Single-page site with no SEO depth",
      whatWeLike: ["One page = one ranking opportunity. Real local SEO needs 15+ indexable pages minimum."],
    },
    {
      rank: 10,
      name: "No 301 redirects from old URLs after a rebuild",
      whatWeLike: ["Rebuilds that don't redirect every old URL lose 60%+ of organic traffic on day one. Map every URL."],
    }
  ],
  closing: "Fix the top three on this list and you'll likely double your inbound leads inside 90 days. No new ad spend required.",
  relatedLinks: [
    { to: "/colorado-springs-web-design", label: "colorado springs web design" },
    { to: "/case-studies", label: "case studies" },
    { to: "/pricing", label: "pricing" }
  ],
};

export const Route = createFileRoute("/top-10-colorado-small-business-website-mistakes")({
  head: () => buildListicleHead(CONFIG),
  component: () => <ListiclePage config={CONFIG} />,
});
